import type {BlindLevel} from '../../types/domain'
import React from 'react'
import Countdown from '../countdown/Countdown'
import Typography from '@mui/material/Typography'


function Level({
  isCurrentLevel,
  length,
  lastLevel,
  clockIsRunning,
  countdownCompleteCallback,
  secondsLeftInCurrentSession
}: {isCurrentLevel: boolean; length: number; lastLevel: boolean; clockIsRunning: boolean; countdownCompleteCallback: () => void; secondsLeftInCurrentSession: number; blind: BlindLevel; level: number; onBreak: boolean}) {
  return (
    <>
      {!lastLevel && isCurrentLevel &&
        <Countdown lengthInSeconds={length * 60}
          clockIsRunning={clockIsRunning}
          onCountdownComplete={countdownCompleteCallback}
          secondsLeftInCurrentSession={secondsLeftInCurrentSession}/>
      }
      {!isCurrentLevel &&
        <Typography sx={{lineHeight: 1.2, fontSize: 'clamp(2rem, 6vw, 5rem)', fontWeight: 700}}>
          {length}:00
        </Typography>
      }
      {lastLevel &&
        <Typography sx={{lineHeight: 1.2, fontSize: 'clamp(2rem, 6vw, 5rem)', fontWeight: 700}}>
          Sudden Death
        </Typography>
      }
    </>
  )
}

export default Level
